<template>
  <div class="event-block">
      <div class="line">
        <span class="item">
          <input type="text" v-model="event_item.name" v-on:change="nameChange" :id="'name_' + event_item.id" name="event_name" class="eventName"/>
        </span>
      </div>
      <form v-on:change="dateChange($event)" autocomplete="off">
        <table style="width: 70%; margin-left: auto; margin-right: auto;">
          <hr style="border: dashed 2px; border-style: none none dashed; color: white" />
          <tr>
            <div>
              <td><label :for="'startyear_' + event_item.id">Start Year </label></td>
              <td><input autocomplete="off" type="text" :id="'startyear_' + event_item.id" :name="'startyear_' + event_item.id" :value="event_item.startDate.getFullYear()"/></td>
            </div>
          </tr>
          <tr>
            <div>
              <td><label :for="'startmonth_' + event_item.id">Month</label></td>
                <td><select :id="'startmonth_' + event_item.id" :name="'startmonth_' + event_item.id" :value="event_item.startDate.getMonth()">
                  <option disabled value="">Month</option>
                  <option value="0">January</option>
                  <option value="1">February</option>
                  <option value="2">March</option>
                  <option value="3">April</option>
                  <option value="4">May</option>
                  <option value="5">June</option>
                  <option value="6">July</option>
                  <option value="7">August</option>
                  <option value="8">September</option>
                  <option value="9">October</option>
                  <option value="10">November</option>
                  <option value="11">December</option>
                </select></td>
            </div>
          </tr>
          <tr>
            <div>
                <td><label :for="'startday_' + event_item.id">Day</label></td>
                <td><input autocomplete="off" type="text" :id="'startday_' + event_item.id" :name="'startday_' + event_item.id" :value="event_item.startDate.getDate()"/></td>
            </div>
          </tr>
          <hr style="border: dashed 2px; border-style: none none dashed; color: white" />
          <tr>
            <div>
              <td><label :for="'endyear_' + event_item.id"> End Year </label></td>
              <td><input autocomplete="off" type="text" :id="'endyear_' + event_item.id" :name="'endyear_' + event_item.id" :value="event_item.endDate.getFullYear()"/></td>
            </div>
          </tr>
          <tr>
            <div>
                <td><label :for="'endmonth_' + event_item.id">Month</label></td>
                <td><select :id="'endmonth_' + event_item.id" :name="'endmonth_' + event_item.id" :value="event_item.endDate.getMonth()">
                  <option disabled value="">Month</option>
                  <option value="0">January</option>
                  <option value="1">February</option>
                  <option value="2">March</option>
                  <option value="3">April</option>
                  <option value="4">May</option>
                  <option value="5">June</option>
                  <option value="6">July</option>
                  <option value="7">August</option>
                  <option value="8">September</option>
                  <option value="9">October</option>
                  <option value="10">November</option>
                  <option value="11">December</option>
                </select></td>
              </div>
            </tr>
            <tr>
              <div>
                <td><label :for="'endday_' + event_item.id">Day</label></td>
                <td><input autocomplete="off" type="text" :id="'endday_' + event_item.id" :name="'endday_' + event_item.id" :value="event_item.endDate.getDate()"/></td>
              </div>
            </tr>
          <hr style="border: dashed 2px; border-style: none none dashed; color: white" />
            <tr>
              <div>
                <td><label :for="'dt_' + event_item.id">Duration Type</label></td>
                <td><select :id="'dt_' + event_item.id" :name="'dt_' + event_item.id" :value="event_item.durationType">
                  <option disabled value="">Duration Type</option>
                  <option value="0">Day</option>
                  <option value="1">Month</option>
                  <option value="2">Year</option>
                </select></td>
              </div>
            </tr>
            <tr>
              <div>
                <td><label :for="'dn_' + event_item.id">Duration</label></td>
                <td><input autocomplete="off" type="text" :id="'dn_' + event_item.id" :name="'dn_' + event_item.id" :value="event_item.durationNumber"/></td>
              </div>
            </tr>
            <tr>
              <div v-for="(field, index) in field_names" v-bind:key="field">
                <td><label :for="field + event_item.id">{{field}}</label></td>
                <td><input type="text" v-model="event_item.extra_fields[index]" :id="field + event_item.id" :name="field + event_item.id"/></td>
              </div>
            </tr>
        </table>
      </form>

      <div class="line">
        <span class="item">
          <input type="submit" v-on:click="deleteEvent" value="Delete Event" class="button"/>
        </span>
        <!-- <span class="item">
          <input type="submit" v-on:click="addCause" value="+ Add Cause" class="button"/>
        </span> -->
      </div>
  </div>
</template>

<script>
export default {
  name: 'EventBlock',
  props: ["event_item", "field_names"],
  methods: {
    deleteEvent() {
      this.$emit('delete-event', this.event_item.id);
    },
    dateChange(event) {
      if (!event.srcElement.value || isNaN(event.srcElement.value)) {
        alert("Dates need to be a number!");
        this.$emit('error-alert', JSON.stringify({error: "Event Edit: Dates need to be a number!", event_data: event}));
      } else {
        this.$emit('date-change', {id: this.event_item.id, changed: event.srcElement.name.split("_", 1)[0], newVal: parseInt(event.srcElement.value)});
      }
    },
    nameChange() {
      this.$emit('name-change', JSON.stringify({event_id: this.event_item.id, new_name: this.event_item.name}));
    }
  }
}
</script>

<style scoped>
.event-block {
  background-color: var(--block-orange);
  padding: 0.2rem;
  margin-bottom: 0.4rem;
  overflow-y: hidden;
  overflow-x: hidden;
  min-width: 300px;

}

label {
  display: inline-block;
  text-align: left;
  width: 120px;
  text-align: left;
  color: white;
  font-weight: bold;
}

.line {
  padding: 0.2rem;
}

.item {
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}

input {
  display: inline-block;
  text-align: left;
  outline: none;
  border-radius: 2px;
  border-width:0px;
  border:none;
}

.eventName {
  text-align: center;
}

input[type='text'] {
  font-family: system-ui, sans-serif;
  font-weight: 500;
}

.button {
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 2px;

}

.button:hover{
  cursor: pointer;
}

</style>
